import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { adminDificultad, getDificultades } from "Services/dificultad_service";

const initialState = {
    dificultades: [],
    dificultad: {
        nombre: '',
        estado: 1,
    },
}

export const dificultadSlice = createSlice({
    name: 'dificultad',
    initialState,
    reducers: {
        setDificultades: (state, action) => {
            state.dificultades = action.payload;
        },
        setDificultad: (state, action) => {
            state.dificultad = action.payload ?? initialState.dificultad;
        },
        updateDificultadField: (state, action) => {
            const { name, value } = action.payload;
            state.dificultad[name] = value;
        },
        resetDificultad: () => initialState,
    }
});

export const fetchDificultades = createAsyncThunk(
    'dificultad/fetchDificultades',
    async (_, { dispatch }) => {
        const dificultadRes = await getDificultades();
        dispatch(setDificultades(dificultadRes));
    }
);

export const mergeDificultad = createAsyncThunk(
    'dificultad/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const dificultadRes = await adminDificultad(data);
        dispatch(setResponse(dificultadRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchDificultades());
        dispatch(resetDificultad())
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setDificultad, setDificultades, updateDificultadField, resetDificultad } = dificultadSlice.actions;
export default dificultadSlice.reducer;
